/**
 * Nút "Nghe" cho câu hỏi có audio đề (`audio_url` — gói nội dung F-Future, plan 2026-10-27).
 * Nghe lại không giới hạn, không tự phát. Dùng ở QuizTake, QuizReview, QuizBuilder.
 */
import { useEffect, useRef, useState } from "react";
import { Button } from "antd";
import { PauseCircleOutlined, SoundOutlined } from "@ant-design/icons";

export function QuestionAudioButton({
  src,
  size = "middle",
}: {
  src?: string;
  size?: "small" | "middle";
}) {
  const audio = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  useEffect(
    () => () => {
      audio.current?.pause();
    },
    [],
  );
  // Đổi câu (src khác) → dừng audio câu cũ.
  useEffect(() => {
    audio.current?.pause();
    audio.current = null;
    setPlaying(false);
  }, [src]);

  if (!src) return null;

  const toggle = () => {
    if (playing && audio.current) {
      audio.current.pause();
      setPlaying(false);
      return;
    }
    if (!audio.current) {
      audio.current = new Audio(src);
      audio.current.onended = () => setPlaying(false);
      audio.current.onpause = () => setPlaying(false);
    }
    audio.current.currentTime = 0;
    audio.current
      .play()
      .then(() => setPlaying(true))
      .catch(() => setPlaying(false));
  };

  return (
    <Button
      size={size}
      icon={playing ? <PauseCircleOutlined /> : <SoundOutlined />}
      onClick={toggle}
      aria-label="Nghe audio của câu hỏi"
    >
      {playing ? "Dừng" : "Nghe"}
    </Button>
  );
}
